export var Top = 'top';
export var Left = 'left';
export var Right = 'right';
export var Bottom = 'bottom';

export var Index  = 'index';
export var Label  = 'label';
export var Offset = 'offset';
export var Perc   = 'perc';
export var Size   = 'size';
export var Total  = 'total';
export var Value  = 'value';

export var GuideLabelStyle = 'guide-label';
export var GuideTitleStyle = 'guide-title';
export var GroupTitleStyle = 'group-title';

export var LegendScales = [
  'shape',
  'size',
  'fill',
  'stroke',
  'strokeDash',
  'opacity'
];

export var Skip = {
  name: 1,
  interactive: 1
};



// WEBPACK FOOTER //
// ./~/vega-parser/src/parsers/guides/constants.js